// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:53:29

export default {
  "id": "words-with-owl-1",
  "slug": "words-with-owl-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f44a159d660b4b9289f9add40a3cd7c0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f44a159d660b4b9289f9add40a3cd7c0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Words with Owl",
      "description": "Test your spelling skills and word recognition in this fun and challenging game! Complete words by filling in the missing letters and aim for the highest score. Unlock exciting new stages as you progress and enjoy a rewarding wordplay experience.",
      "instructions": "You'll be given incomplete words with missing letters—your goal is to click the letters in the correct order to complete them. Think fast and act quickly to earn more stars before time runs out. The faster you are, the higher your score!",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "singleplayer"
      ]
    },
    "zh-CN": {
      "title": "《猫头鹰单词》",
      "description": "测试你的拼写技巧和单词识别能力，在这款有趣且富有挑战性的游戏中！通过填补缺失的字母来完成单词，争取获得最高分。随着你的进步解锁令人兴奋的新阶段，享受令人满意的文字游戏体验。",
      "instructions": "您将得到不完整的单词，缺失字母——您的目标是按照正确的顺序点击字母来完成它们。快速思考，迅速行动，在时间耗尽前赢得更多星星！您越快，分数越高！",
      "genres": [
        "谜题",
        "问答"
      ],
      "tags": [
        "单人模式"
      ]
    },
    "zh-TW": {
      "title": "有烏鴉的單字",
      "description": "測試你的拼寫技巧和單詞識別能力，在這款好玩且挑戰性的遊戲中！透過填入缺少的字母來完成單詞，並追求最高的分數。隨著進展解鎖令人興奮的新階段，享受獎勵豐厚的文字遊戲體驗。",
      "instructions": "你將獲得不完整的單詞，並且缺少字母——你的目標是按照正確的順序點擊字母來完成它們。快速思考並迅速行動，在時間耗盡前獲得更多星星！你越快，得分越高！",
      "genres": [
        "謎題",
        "問答遊戲"
      ],
      "tags": [
        "單人遊戲"
      ]
    },
    "zh-HK": {
      "title": "有鴞之詞",
      "description": "挑戰你的拼寫技巧和字詞識別能力！這是一款有趣而挑戰性的遊戲！完成單詞，填入缺少的字母，並為最高分數奮鬥。隨著進步，解鎖令人興奮的新關卡，並享受獎勵豐厚的文字遊戲體驗。",
      "instructions": "你將被給予不完整的單詞，缺少字母—你的目標是按正確的順序點擊字母來完成它們。快思善行，在時間結束前獲得更多星星！你越快，得分越高！",
      "genres": [
        "謎題",
        "問答"
      ],
      "tags": [
        "單人遊戲"
      ]
    },
    "ja": {
      "title": "「オウルの言葉」",
      "description": "スペル力と単語認識を楽しみながら挑戦するこの面白くて挑戦的なゲームで、欠けている文字を埋めて単語を完成させ、最高得点を目指せ。進むにつれて魅力的な新しいステージを解除し、報酬のあるパズル体験を楽しむ。",
      "instructions": "不完全な言葉が与えられ、欠けている文字をクリックして完成させるのが目標です。時間が切れる前に多くの星を稼ぐために、素早く考えると速く行動することが重要です。早ければ高いスコアが得られます！",
      "genres": [
        "パズル",
        "クイズ"
      ],
      "tags": [
        "シングルプレイヤー"
      ]
    },
    "ko": {
      "title": "오우루의 단어",
      "description": "이 재미있고 도전적인 게임에서 스펠링 능력과 단어 인식력을 테스트하세요! 빠른 글자를 채워 단어를 완성하여 가장 높은 점수를 목표로하세요. 진행하면서 흥미로운 새로운 단계를 해금하고, 보상을 받는 단어 놀이 경험을 즐겨보세요.",
      "instructions": "빈자리가 있는 단어를 주어지고, 이를 완성하기 위해 정확한 순서로 글자를 클릭하세요. 빠르게 생각하고 빠르게 행동하여 시간이 지기 전에 더 많은 별을 얻으세요. 더 빠르면 더 높은 점수를 받을 수 있습니다!",
      "genres": [
        "퍼즐",
        "퀴즈"
      ],
      "tags": [
        "단일 플레이어"
      ]
    },
    "fr": {
      "title": "Mots avec hibou",
      "description": "Testez vos compétences en orthographe et en reconnaissance de mots dans ce jeu amusant et défiant ! Complétez les mots en remplissant les lettres manquantes et visez le plus haut score. Débloquez des niveaux nouveaux et captivants à mesure que vous progressez et profitez d'une expérience ludique récompensante.",
      "instructions": "Vous serez donné des mots incomplets avec des lettres manquantes — votre objectif est de cliquer sur les lettres dans l'ordre correct pour les compléter. Réfléchissez vite et agissez rapidement pour gagner plus de étoiles avant que le temps ne se termine. Plus vous êtes rapide, plus votre score est élevé !",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "Joueur solo"
      ]
    }
  }
};
